import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';
import gsap from 'gsap';
import '../styles/app.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import imagePath from '@images/spinner.gif'

import articlesLoader from './components/articles';
import newsLoader from './components/news';
// import initPinScroll from './components/pin-scroll';
// import initVideoBackground from './components/video-comp';
// import initTwoRowSlider from './components/double-slider';
// import newsLoader from './components/news';
import initHighlightScroll from './components/highlight-scroll';
import inittimelineCompare from './components/timeline-compare';
import initTimelineDevelopment from './components/timeline-development';
import initEbookSlider from './components/ebooks-slider';
import initPipeline from './components/pipeline-scroll';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

window.$ = window.jQuery = $;

$(document).ready(function () {
  $(document).foundation();

  $('.callout').on('click', '.close-button', function() {
    localStorage.setItem('SeenPopup', 'true');
  });

  if (localStorage.getItem('SeenPopup')) {
    $('.callout').hide();
  } else {
    $('.callout').removeClass('hide');
  }

  $('.hamburger').on('click', function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('locked');
    $('.top-bar').toggleClass('open');
  });

  function addToggleAtBreakpoint() {
      if ($(window).width() <= 1024) {
        $('.menu li.menu-item-has-children').each(function () {
          if ($(this).find('.submenu-toggle').length === 0) {
            $(this).append('<span class="submenu-toggle"></span>');
          }
        });
      } else {
        $('.menu li.menu-item-has-children .submenu-toggle').hide();
      }
    }

    // Run on page load
    addToggleAtBreakpoint();

    // Run on window resize
    $(window).on('resize', function () {
      addToggleAtBreakpoint();
    });

    $('.top-bar').on('click', '.submenu-toggle', function () {
      $(this).toggleClass('open');
      $(this).parent().toggleClass('sub-active');
      $(this).prev().slideToggle();

      if ($('.submenu-toggle').hasClass('open')) {
        $('.top-bar').addClass('mob-overflow');
      } else {
        $('.top-bar').removeClass('mob-overflow');
      }
    });

    const $topBar = $('.top-bar');

    // Reset all submenus
    function resetSubmenus() {
      $topBar.find('li.parent').removeClass('keyboard-open');
      $topBar.find('.sub-menu').removeClass('visible').attr('aria-hidden', 'true');
      $topBar.find('.sub-menu a').attr('tabindex', '-1');
    }

    // Initial setup
    resetSubmenus();

    // Open submenu on keyboard (Enter or Space)
    $topBar.on('keydown', 'li.parent > a', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        const $parent = $(this).parent();
        const $submenu = $parent.find('.sub-menu');

        const isOpen = $parent.hasClass('keyboard-open');

        resetSubmenus(); // close all others first

        if (!isOpen) {
          $parent.addClass('keyboard-open');
          $submenu.addClass('visible').attr('aria-hidden', 'false');
          $submenu.find('a').attr('tabindex', '0');
        }
      }
    });

  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        once: true,
        offset: 160,               // Trigger slightly sooner
        duration: 400,             // Shorter duration = faster animation
        easing: 'ease-out-sine',   // Smoother, softer exit curve
      });
    }
  }

  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refreshHard();
    }
  }, 500); // gives slick time to stabilize layout


  // Hero Link Checker (in-page versus off page)

  const heroLink = document.querySelector('.hero-area a');
  if (heroLink) {
    heroLink.addEventListener('click', function(e) {
      const href = heroLink.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top,
            behavior: 'smooth'
          });
          history.replaceState(null, '', href);
        }
      }
    });
  }

  const hasPinScroll = document.querySelector('.pin-scroll-component');

  if (hasPinScroll) {
    // Delay AOS init until pin scroll layout is settled
    setTimeout(() => {
      initAOS();
    }, 500); // adjust if needed
  } else {
    // No pin scroll — safe to init immediately
    initAOS();
  }

  const $firstItem = $('.accordion .accordion-item').first();
  $firstItem.addClass('is-active');
  $firstItem.find('.accordion-content').addClass('is-active').attr('aria-hidden', 'false').css('display', 'block');

  // Logo Slider

  $('.logo-slider-wrap').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrow: false,
    dots: false,
    infinite: true,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
      }
    }
    ]
  });

  // Testimonial Slider

  $('.testimonial-slider-wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    centerMode: false,
    variableWidth: true,
    prevArrow: $('.slider-prev'),
    nextArrow: $('.slider-next'),
  })

  $('.past-events-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: false,
    arrows: true,
    dots: false,
    prevArrow: $('.slider-prev'),
    nextArrow: $('.slider-next'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // initTwoRowSlider();

  window.addEventListener('load', () => {
    articlesLoader();
    newsLoader();
    // initPinScroll();
    // initVideoBackground();
    // newsLoader();
    initHighlightScroll();
    inittimelineCompare();
    initTimelineDevelopment();
    initPipeline();
    initEbookSlider();
  });

  // SVG Animation

  const anchors = document.querySelectorAll('#webgraph ellipse');
  const paths = document.querySelectorAll('#webgraph path');

  // Animate all anchors randomly
  anchors.forEach((anchor, i) => {
    gsap.to(anchor, {
      duration: 3 + Math.random() * 2,
      repeat: -1,
      yoyo: true,
      attr: {
        cx: `+=${Math.random() * 30 - 15}`,
        cy: `+=${Math.random() * 30 - 15}`
      },
      onUpdate: updatePaths
    });
  });

  // Recalculate all path `d` values on every anchor update
  function updatePaths() {
    paths.forEach(path => {
      const anchorIds = path.getAttribute('data-anchors').split(' ');
      const anchor1 = document.getElementById(anchorIds[0]);
      const anchor2 = document.getElementById(anchorIds[1]);

      const x1 = anchor1.getAttribute('cx');
      const y1 = anchor1.getAttribute('cy');
      const x2 = anchor2.getAttribute('cx');
      const y2 = anchor2.getAttribute('cy');

      // Use a midpoint as a simple control point (for a quadratic curve)
      const cx = (parseFloat(x1) + parseFloat(x2)) / 2;
      const cy = (parseFloat(y1) + parseFloat(y2)) / 2;

      const newD = `M${x1},${y1} Q${cx},${cy} ${x2},${y2}`;
      path.setAttribute('d', newD);
    });
  }


  $(document).on('closed.zf.reveal', '[data-reveal]', function () {
    const $modal = $(this);

    // Stop Vimeo using Player API
    $modal.find('iframe[src*="vimeo.com"]').each(function () {
      const player = new Vimeo.Player(this);
      player.pause().catch(function (error) {
        console.error('Vimeo pause error:', error);
      });
    });

    // Stop YouTube (reset src)
    $modal.find('iframe[src*="youtube.com"]').each(function () {
      const $iframe = $(this);
      const src = $iframe.attr('src');
      $iframe.attr('src', '');
      $iframe.attr('src', src);
    });

    // Stop native HTML5 videos
    $modal.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  });

  //News/ Webinar Feed
  (function ($) {
    function initPanelIfNeeded($panel) {
      if (!$panel || !$panel.length) return;
      const $slider = $panel.find('.ne-slider');
      if (!$slider.length) return;

      if ($slider.hasClass('slick-initialized')) {
        // panel just became visible → recalc widths
        $slider.slick('setPosition');
        return;
      }

      // edge fades (optional)
      $slider.on('init reInit afterChange', function (e, slick, current) {
        const cur = typeof current === 'number' ? current : slick.currentSlide;
        const atStart = cur === 0;
        const atEnd   = cur >= slick.slideCount - slick.options.slidesToShow;
        $panel.toggleClass('at-start', atStart);
        $panel.toggleClass('at-end',   atEnd);
      });

      $slider.on('init reInit afterChange setPosition breakpoint', function (e, slick) {
        const total = slick.slideCount;
        const shown = slick.options.slidesToShow;
        const hasOverflow = total > shown;

        const $prev = $panel.find('.ne-prev');
        const $next = $panel.find('.ne-next');

        // disable when no overflow
        $prev.prop('disabled', !hasOverflow).attr('aria-disabled', !hasOverflow);
        $next.prop('disabled', !hasOverflow).attr('aria-disabled', !hasOverflow);
      });

      // init slick
      $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: false,
        arrows: true,
        dots: false,
        prevArrow: $panel.find('.ne-prev'),
        nextArrow: $panel.find('.ne-next'),
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 3 } },
          { breakpoint: 900,  settings: { slidesToShow: 2 } },
          { breakpoint: 600,  settings: { slidesToShow: 1 } }
        ]
      });
    }

    $(document).ready(function () {
      const $tabsContent = $('.tabs-content[data-tabs-content="news-events-tabs"]');
      if (!$tabsContent.length) return;

      // 1) Initialize whichever panel is already active after Foundation sets classes
      requestAnimationFrame(() => {
        initPanelIfNeeded($tabsContent.find('.tabs-panel.is-active'));
      });

      // 2) Observe class changes on panels; when one gains "is-active", init it
      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            const el = m.target;
            if (el.classList.contains('tabs-panel') && el.classList.contains('is-active')) {
              initPanelIfNeeded($(el));
            }
          }
        }
      });

      // watch all panels
      $tabsContent.find('.tabs-panel').each((_, panel) => {
        observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
      });

      // 3) Fallback: click on tab links
      $('#news-events-tabs').on('click', 'a', function () {
        const href = $(this).attr('href');
        if (!href) return;
        // allow Foundation to toggle classes, then init
        setTimeout(() => initPanelIfNeeded($(href)), 0);
      });

      // 4) On resize, keep slides measured correctly
      $(window).on('resize', Foundation.util.throttle(function () {
        $('.ne-slider.slick-initialized').slick('setPosition');
      }, 150));
    });
  })(jQuery);


// Video Modal Foundation Reveal + video control
$(document)
  .on('open.zf.reveal', '.video-reveal', function () {
    const $modal = $(this);

    // pause hero background video
    const hero = document.querySelector('.video-hero .video-hero__video');
    if (hero && !hero.paused) { try { hero.pause(); } catch(e){} }

    // lazy-inject iframe
    const $holder = $modal.find('.embed-holder[data-embed-src]');
    if ($holder.length && !$holder.data('loaded')) {
      const src = $holder.data('embed-src');
      const iframe = document.createElement('iframe');
      iframe.width = '100%';
      iframe.height = '315';
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder','0');
      $holder.empty().append(iframe).data('loaded', true);
    }

    // autoplay uploaded video
    const up = $modal.find('video.modal-upload').get(0);
    if (up) {
      const p = up.play();
      if (p && p.catch) p.catch(()=>{});
    }
  })
  .on('closed.zf.reveal', '.video-reveal', function () {
    const $modal = $(this);

    // remove iframe to stop YT/Vimeo
    $modal.find('.embed-holder[data-embed-src]').each(function(){
      $(this).data('loaded', false).empty();
    });

    // stop uploaded video
    $modal.find('video.modal-upload').each(function () {
      try { this.pause(); this.currentTime = 0; } catch(e){}
    });

    // resume hero background
    const hero = document.querySelector('.video-hero .video-hero__video');
    if (hero) {
      const p = hero.play();
      if (p && p.catch) p.catch(()=>{});
    }
  });
  
  // ---- Parallax for hero video tab background (GSAP + ScrollTrigger) ----
  gsap.registerPlugin(ScrollTrigger);

  (function initHeroParallax() {
    const host  = document.querySelector('.hero-cluster');
    const layer = document.querySelector('.hero-cluster__bg-inner');
    if (!host || !layer) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const BASE = () => Math.min(window.innerHeight * 0.35, 480); 

    // start slightly above and scaled up (End below and back to 1)
    gsap.fromTo(layer,
      { y: () => -BASE() * 0.22, scale: 1.08 },
      { y: () =>  BASE(),        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: host,
          start: 'top top',
          end:   'bottom top',
          scrub: 0.6,
          invalidateOnRefresh: true,
          id: 'hero-parallax',
        }
      }
    );

    gsap.to('.hero-cluster__bg-inner', {
      x: () => '5vw',
      ease: 'none',
      scrollTrigger: {
        trigger: '.hero-cluster',
        start: 'top top',
        end:   'bottom top',
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    window.addEventListener('load', () => ScrollTrigger.refresh());
  })();


  // ---- Vertical Tabs: animate stat lines  ----
  gsap.registerPlugin(ScrollTrigger);

  (function initVerticalTabLines() {
    $('.vertical-tabs').each(function () {
      const $section = $(this);
      const $tabsUl  = $section.find('.vt-tabs');

      // Create the animation for a given panel
      function animatePanel($panel) {
        if (!$panel || !$panel.length) return;

        const lines = $panel.find('.animated-line').toArray();
        if (!lines.length) return;

        //Reset
        gsap.killTweensOf(lines);
        gsap.set(lines, { scaleX: 0 });

        const tl = gsap.timeline();
        tl.to(lines, {
          scaleX: 1,
          duration: 0.9,              // slow the draw
          stagger: 0.35,              // one after another
          ease: "power2.out",
          delay: 0.15
        });

        return tl;
      }

      // 1) First time the section enters the viewport: animate ACTIVE panel
      const $initialPanel = $section.find('.tabs-panel.is-active');
      ScrollTrigger.create({
        trigger: $section[0],
        start: "top 70%",
        once: true,
        onEnter: () => animatePanel($initialPanel)
      });

      // 2) Re-animate when tabs change
      function handleTabChange(e, payload) {
        let $panel = $();

        if (payload && payload.jquery) {
          if (payload.is('.tabs-panel')) {
            $panel = payload;
          } else if (payload.is('a') && payload.attr('href')) {
            $panel = $section.find(payload.attr('href'));
          }
        } else if (payload && payload.tagName) {
          const $el = $(payload);
          if ($el.is('.tabs-panel')) $panel = $el;
          else if ($el.is('a') && $el.attr('href')) $panel = $section.find($el.attr('href'));
        }

        if (!$panel.length) $panel = $section.find('.tabs-panel.is-active');

        requestAnimationFrame(() => animatePanel($panel));
      }

      $tabsUl.on('change.zf.tabs', handleTabChange);

      // 3) Extra safety
      const observer = new MutationObserver(muts => {
        muts.forEach(m => {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            const el = m.target;
            if (el.classList.contains('tabs-panel') && el.classList.contains('is-active')) {
              animatePanel($(el));
            }
          }
        });
      });

      $section.find('.tabs-panel').each((_, panel) => {
        observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
      });
    });
  })();


  //Metrics Repeater Animation Line

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.metrics-repeater').forEach(section => {
    const rules = section.querySelectorAll('.metrics-repeater__rule');
    if (!rules.length) return;

    if (reduceMotion) {
      rules.forEach(el => {
        el.style.transform = 'scaleX(1)';
        el.style.opacity = '1';
      });
      return;
    }

    rules.forEach((el) => {
      const card = el.closest('.metrics-repeater__card') || el;

      gsap.fromTo(el,
        { scaleX: 0, opacity: 0.5 },
        {
          scaleX: 1,
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: card,
            start: 'top 80%',
            once: true,
          }
        }
      );
    });
  });

  //Feature Scroll
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-ffsf]").forEach(section => {
    const img      = section.querySelector(".ffsf-img");
    const list     = section.querySelector(".ffsf-list");
    const items    = Array.from(section.querySelectorAll(".ffsf-item"));
    const progress = section.querySelector(".ffsf-vt__progress");
    const track    = section.querySelector(".ffsf-vt__track");
    if (!img || !list || !items.length || !progress || !track) return;

    const maxScrollY = () => Math.max(0, list.scrollHeight - list.clientHeight);

    // ---------- 1) Size + minimal bottom padding so last item can reach center ----------
    const setHeights = () => {
      const h = img.clientHeight;
      if (h > 0) {
        list.style.height = h + "px";
        section.querySelector(".ffsf-copy").style.minHeight = h + "px";
      }

      const last = items[items.length - 1];
      const listH = list.clientHeight;
      const targetY = listH * 0.45;
      const lastHalf = (last?.offsetHeight || 0) / 2;

      let pad = Math.round(targetY - (listH - lastHalf));
      if (!Number.isFinite(pad)) pad = 0;

      list.style.paddingBottom = Math.max(0, pad) + "px";

      ScrollTrigger.refresh();
    };
    if (img.complete) setHeights(); else img.addEventListener("load", setHeights, { once:true });
    window.addEventListener("resize", setHeights, { passive:true });

    // ---------- 2) ScrollTrigger highlight per item ----------
    items.forEach((item) => {
      ScrollTrigger.create({
        scroller: list,
        trigger:  item,
        start:    "top 45%",
        end:      "bottom 45%",
        toggleClass: { targets: item, className: "is-active" },
      });
    });

    // ---------- 2b) Manual activation pass (init + scroll) ----------
    // Ensures the nearest-to-center item is active at load and while scrolling.
    const centerActivate = () => {
      const mid = list.scrollTop + list.clientHeight * 0.45;
      let bestIdx = 0;
      let bestDist = Infinity;

      items.forEach((it, idx) => {
        const y = it.offsetTop + it.offsetHeight / 2;
        const d = Math.abs(y - mid);
        if (d < bestDist) {
          bestIdx = idx;
          bestDist = d;
        }
      });

      items.forEach(el => el.classList.remove('is-active'));
      items[bestIdx].classList.add('is-active');
    };

    // at absolute bottom, force last item active
    const ensureLastAtBottom = () => {
      if (list.scrollTop >= maxScrollY() - 1) {
        items.forEach(el => el.classList.remove("is-active"));
        items[items.length - 1].classList.add("is-active");
      }
    };

    // Run once after ST builds, then on scroll
    ScrollTrigger.addEventListener('refreshInit', centerActivate);
    list.addEventListener('scroll', () => { centerActivate(); ensureLastAtBottom(); }, { passive:true });

    // ---------- 3) pointer thumb follows scroll ----------
    const travel = () => Math.max(0, track.clientHeight - progress.offsetHeight);

    if (reduce) {
      progress.style.transform = `translateY(${travel()}px)`;
    } else {
      gsap.fromTo(
        progress,
        { y: 0 },
        {
          y: () => travel(),
          ease: "none",
          invalidateOnRefresh: true,
          scrollTrigger: {
            scroller: list,
            trigger:  list,
            start:    "top top",
            end:      () => "+=" + (list.scrollHeight - list.clientHeight),
            scrub:    true,
          }
        }
      );
    }

    // ---------- 4) Drag the thumb to scroll ----------
    let dragging = false;
    let startY = 0;
    let startProgY = 0;

    const maxThumbY  = () => Math.max(0, track.clientHeight - progress.offsetHeight);
    const getThumbYFromScroll = () => {
      const r = maxScrollY() ? (list.scrollTop / maxScrollY()) : 0;
      return r * maxThumbY();
    };
    const setScrollFromThumbY = (y) => {
      const clamped = Math.max(0, Math.min(y, maxThumbY()));
      const r = maxThumbY() ? clamped / maxThumbY() : 0;
      list.scrollTop = r * maxScrollY();
    };

    progress.addEventListener('mousedown', (e) => {
      dragging   = true;
      startY     = e.clientY;
      startProgY = getThumbYFromScroll();
      progress.classList.add('dragging');
      section.classList.add('is-dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      const dy = e.clientY - startY;
      setScrollFromThumbY(startProgY + dy);
    });
    window.addEventListener('mouseup', () => {
      if (!dragging) return;
      dragging = false;
      progress.classList.remove('dragging');
      section.classList.remove('is-dragging');
    });

    // touch
    progress.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      dragging   = true;
      startY     = t.clientY;
      startProgY = getThumbYFromScroll();
      progress.classList.add('dragging');
      section.classList.add('is-dragging');
      e.preventDefault();
    }, { passive: false });
    window.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      const t = e.touches[0];
      const dy = t.clientY - startY;
      setScrollFromThumbY(startProgY + dy);
      e.preventDefault();
    }, { passive: false });
    window.addEventListener('touchend', () => {
      if (!dragging) return;
      dragging = false;
      progress.classList.remove('dragging');
      section.classList.remove('is-dragging');
    });

    // Initial pass so first item is active right away
    centerActivate();
  });

// ----- Advisors "See more" loader -----
function wireAdvisorNeighbors() {
  const cards = Array.from(document.querySelectorAll('.advisors-grid [data-advisor-id]'));
  if (!cards.length) return;

  const ids = cards
    .map(el => parseInt(el.getAttribute('data-advisor-id'), 10))
    .filter(Boolean);

  ids.forEach((id, i) => {
    const prevId = ids[(i - 1 + ids.length) % ids.length];
    const nextId = ids[(i + 1) % ids.length];

    const modal = document.getElementById(`advisor-modal-${id}`);
    if (!modal) return;

    if (window.jQuery && window.Foundation) {
      const $m = jQuery(modal);
      if (!$m.data('zfPlugin')) new Foundation.Reveal($m);
    }

    let nav = modal.querySelector('.advisor-modal__nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'advisor-modal__nav';
      modal.appendChild(nav);
    }
    nav.innerHTML = `
      <button type="button" class="button hollow tiny advisor-modal__nav-btn"
              data-open="advisor-modal-${prevId}" aria-label="Previous advisor"><svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.0433 11.4205L0.531938 5.90909L6.0433 0.397727L7.21376 1.55682L3.70807 5.0625H12.2251V6.75568H3.70807L7.21376 10.2557L6.0433 11.4205Z" fill="white"/>
              </svg></button>
      <button type="button" class="button hollow tiny advisor-modal__nav-btn"
              data-open="advisor-modal-${nextId}" aria-label="Next advisor"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.18182 11.4205L5.01136 10.2614L8.51705 6.75568H0V5.0625H8.51705L5.01136 1.5625L6.18182 0.397727L11.6932 5.90909L6.18182 11.4205Z" fill="white"/>
              </svg></button>
    `;
  });
}

wireAdvisorNeighbors();

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.see-more-advisors');
  if (!btn) return;

  const grid = document.querySelector('.advisors-grid');
  if (!grid) return;

  const ajaxUrl  = (window.wpData && window.wpData.ajaxUrl) ? window.wpData.ajaxUrl : '/wp-admin/admin-ajax.php';
  const offset   = parseInt(grid.dataset.offset, 10)  || 0;
  const perPage  = parseInt(grid.dataset.perpage, 10) || 4;
  const nonce    = grid.dataset.nonce;

  btn.disabled = true;
  const oldText = btn.textContent;
  btn.textContent = 'Loading…';

  try {
    const res = await fetch(ajaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams({
        action: 'load_advisors_cpt',
        offset: offset,
        per_page: perPage,
        nonce: nonce,
      }),
    });

    const raw = await res.text();
    const data = JSON.parse(raw);

    if (data.success) {
      grid.insertAdjacentHTML('beforeend', data.data.html);
      grid.dataset.offset = data.data.offset;

      if (window.jQuery && window.Foundation) {
        jQuery(grid).find('.reveal').each(function () {
          if (!jQuery(this).data('zfPlugin')) { new Foundation.Reveal(jQuery(this)); }
        });
      }

      wireAdvisorNeighbors();

      if (!data.data.has_more) {
        // remove button
        btn.closest('.row') ? btn.closest('.row').remove() : btn.remove();
        // remove fade
        const fade = document.querySelector('.advisors-team .advisors-fade');
        if (fade) fade.remove();
      }
    } else {
      console.error('AJAX error:', data.data?.message || 'Unknown error');
    }
  } catch (err) {
    console.error(err);
  } finally {
    // If button still exists, restore label/state
    if (document.body.contains(btn)) {
      btn.textContent = oldText;
      btn.disabled = false;
    }
  }
});

document.addEventListener('keydown', (e) => {
  const openModal = document.querySelector('.reveal.advisor-reveal.is-revealed');
  if (!openModal) return;
  if (e.key === 'ArrowRight') openModal.querySelector('.advisor-modal__nav-btn:last-child')?.click();
  if (e.key === 'ArrowLeft')  openModal.querySelector('.advisor-modal__nav-btn:first-child')?.click();
});

//Leadership modal next/prev

function openRevealById(id) {
  const el = document.getElementById(id);
  if (!el || !window.jQuery || !window.Foundation) return;

  const $el = jQuery(el);
  let inst = $el.data('zfPlugin');
  if (!inst) inst = new Foundation.Reveal($el);

  inst.open();
}

function closeReveal(el) {
  if (!el || !window.jQuery || !window.Foundation) return;

  const $el = jQuery(el);
  const inst = $el.data('zfPlugin') || new Foundation.Reveal($el);
  inst.close();
}

function wireLeadershipNeighbors() {
  // all leadership modals on the page
  const modals = Array.from(document.querySelectorAll('.reveal.advisor-reveal[id^="leader-modal-"]'));
  if (!modals.length) return;

  // keep them in numeric order by the trailing number
  modals.sort((a, b) => {
    const ai = parseInt((a.id.match(/leader-modal-(\d+)/) || [])[1] || "0", 10);
    const bi = parseInt((b.id.match(/leader-modal-(\d+)/) || [])[1] || "0", 10);
    return ai - bi;
  });

  const ids = modals.map(m => m.id);

  ids.forEach((id, i) => {
    const prevId = ids[(i - 1 + ids.length) % ids.length];
    const nextId = ids[(i + 1) % ids.length];

    const modal = document.getElementById(id);
    if (!modal) return;

    // Ensure Reveal initialized
    if (window.jQuery && window.Foundation) {
      const $m = jQuery(modal);
      if (!$m.data('zfPlugin')) new Foundation.Reveal($m);
    }

    let nav = modal.querySelector('.advisor-modal__nav');
    if (!nav) return;

    nav.innerHTML = `
      <button type="button" class="button hollow tiny advisor-modal__nav-btn"
              data-leader-open="${prevId}" aria-label="Previous leader">
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.0433 11.4205L0.531938 5.90909L6.0433 0.397727L7.21376 1.55682L3.70807 5.0625H12.2251V6.75568H3.70807L7.21376 10.2557L6.0433 11.4205Z" fill="white"></path>
        </svg>
      </button>

      <button type="button" class="button hollow tiny advisor-modal__nav-btn"
              data-leader-open="${nextId}" aria-label="Next leader">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.18182 11.4205L5.01136 10.2614L8.51705 6.75568H0V5.0625H8.51705L5.01136 1.5625L6.18182 0.397727L11.6932 5.90909L6.18182 11.4205Z" fill="white"></path>
        </svg>
      </button>
    `;
  });
}

// Click handler: switch modals
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-leader-open]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const targetId = btn.getAttribute('data-leader-open');
  const currentModal = btn.closest('.reveal.advisor-reveal');
  if (!currentModal || !targetId) return;

  if (!window.jQuery || !window.Foundation) return;

  const $current = jQuery(currentModal);

  // Ensure current has a Reveal instance
  if (!$current.data('zfPlugin')) new Foundation.Reveal($current);

  // Open target after current fully closes
  $current.one('closed.zf.reveal', () => {
    openRevealById(targetId);
  });

  // Close current
  $current.foundation('close');
});

// Keyboard arrows when a leadership modal is open
document.addEventListener('keydown', (e) => {
  const openModal = document.querySelector('.leadership-team .reveal.advisor-reveal.is-revealed');
  if (!openModal) return;

  if (e.key === 'ArrowRight') openModal.querySelector('[data-leader-open]:last-child')?.click();
  if (e.key === 'ArrowLeft')  openModal.querySelector('[data-leader-open]:first-child')?.click();
});

// Run once on page load
function whenReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}

whenReady(() => {
  wireLeadershipNeighbors();

  // also re-wire whenever a leadership modal opens (Foundation triggers this)
  document.addEventListener('open.zf.reveal', (e) => {
    const modal = e.target;
    if (modal && modal.id && modal.id.startsWith('leader-modal-')) {
      wireLeadershipNeighbors();
    }
  });
});



//Search Bar
(function($){
  const $panel  = $('#site-search');
  const $input  = $panel.find('.gatc-search__input');
  const OPEN    = 'is-open';

  function openSearch(){
    if ($panel.hasClass(OPEN)) return;
    $panel.addClass(OPEN).attr('aria-hidden','false');
    $('body').addClass('lock-scroll');
    setTimeout(()=> $input.trigger('focus'), 180);
  }

  function closeSearch(){
    $panel.removeClass(OPEN).attr('aria-hidden','true');
    $('body').removeClass('lock-scroll');
  }

  $(document).on('click', '.js-search-open', openSearch);
  $(document).on('click', '.js-search-close', closeSearch);

  // click outside inner to close
  $panel.on('click', function(e){
    if ($(e.target).is('#site-search')) closeSearch();
  });

  // Esc to close
  $(document).on('keydown', function(e){
    if (e.key === 'Escape' && $panel.hasClass(OPEN)) closeSearch();
  });
})(jQuery);


//Events/Webinar Footer CTA Switch on Tab
  (function ($) {
    const $btn = $('#ne-footer-cta');
    if (!$btn.length) return;

    const newsHref  = $btn.attr('data-news-href');
    const newsLabel = $btn.attr('data-news-label');
    const evHref    = $btn.attr('data-events-href');
    const evLabel   = $btn.attr('data-events-label');

    function setFooterCTA(hash) {
      if (hash === '#panel-events') {
        if (evHref)   $btn.attr('href', evHref);
        if (evLabel)  $btn.html(evLabel);
      } else {
        if (newsHref)  $btn.attr('href', newsHref);
        if (newsLabel) $btn.html(newsLabel);
      }
    }

    function activePanelHash() {
      const $active = $('.tabs-content[data-tabs-content="news-events-tabs"] .tabs-panel.is-active');
      return $active.length ? ('#' + $active.attr('id')) : '#panel-news';
    }

    setFooterCTA(activePanelHash());

    $(document).on('change.zf.tabs', '#news-events-tabs', function () {
      setFooterCTA(activePanelHash());
    });

    $('#news-events-tabs').on('click', 'a', function () {
      setTimeout(() => setFooterCTA(activePanelHash()), 0);
    });

    const $tabsContent = $('.tabs-content[data-tabs-content="news-events-tabs"]');
    if ($tabsContent.length) {
      const obs = new MutationObserver(muts => {
        muts.forEach(m => {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            const el = m.target;
            if (el.classList.contains('tabs-panel') && el.classList.contains('is-active')) {
              setFooterCTA('#' + el.id);
            }
          }
        });
      });
      $tabsContent.find('.tabs-panel').each((_, el) =>
        obs.observe(el, { attributes: true, attributeFilter: ['class'] })
      );
    }
  })(jQuery);


  //Smooth Scroll

  $(document).on('click', 'a[href="#careers-split"], a[href="#contact-full-width"]', function (e) {
    var hash = $(this).attr('href');
    var $target = $(hash);
    if (!$target.length) return;

    e.preventDefault();

    var $header = $('.site-header, .header, .sticky-header').first();
    var offset = $header.length ? $header.outerHeight() : 0;

    $('html, body').stop().animate({
      scrollTop: $target.offset().top - offset
    }, 600);
  });

});
